import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./Login.css";
import { Form, Input, Button, Card, message, Row, Col } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../Images/logo.png";
import { loginUser } from "../../Action/Actions";
import { getLoginLoading } from "./LoginSlice";

const Login = () => {
  const Loading = useSelector(getLoginLoading);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const handleValuesChange = (_, allValues) => {
    // console.log("allValues", allValues);
    const { user_name = "", password = "" } = allValues;

    if (user_name.length >= 6 && password.length >= 6) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };
  const onFinish = async (values) => {
    const post = {
      user_name: values?.user_name,
      password: values?.password,
    };

    dispatch(loginUser(post))
      .then((data) => {
        message.success(data?.message);
        // navigate("/corporate/Dashboard");
      })
      .catch((error) => {
        message.error(error);
        form.resetFields();
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="wi-log-outer">
      <div className="container">
        <div className="row w-log-bg">
          <div className="col-xl-6 col-sm-12 py-3">
            <Card
              style={{
                padding: 20,
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                borderRadius: 10,
                textAlign: "center",
              }}
            >
              <img src={Logo} style={{ width: "40%" }}></img>
              <h2
                className="text-center mb-3 mt-3"
                style={{ fontSize: "26px" }}
              >
                Corporate Login
              </h2>

              <Form
                form={form}
                onFinish={onFinish}
                onValuesChange={handleValuesChange}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                autoComplete="off"
              >
                <Form.Item
                  name="user_name"
                  label="Username"
                  rules={[
                    {
                      required: true,
                      message: "Please input a valid Username!",
                    },

                    {
                      type: "email",
                      message: "The input is not a valid email address!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Username"
                    size="large"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>
                <Form.Item
                  className="mb-5"
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "Please input your Password!" },
                    // {
                    //   pattern:
                    //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*()_+=-]{6,18}$/,
                    //   message:
                    //     "Password must be 6-18 characters, with at least one uppercase letter, one lowercase letter, and one number.",
                    // },
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Password"
                    size="large"
                    maxLength={18}
                  />
                </Form.Item>
                <Form.Item>
                  <Row justify="center" align="middle">
                    <Col>
                      <Link to="/ResetPassword">Forgot Password/Username?</Link>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item>
                  <Button
                    loading={Loading}
                    disabled={isButtonDisabled}
                    type="primary"
                    htmlType="submit"
                    size="large"
                    style={{
                      borderRadius: 30,
                      // background: "#021040",
                      border: "none",
                      width: "25%",
                    }}
                  >
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
